<template>
  <div>
    <v-row class="ma-1">
      <v-col cols="6">
        <h1>My Plan</h1>
      </v-col>
      <v-col cols="6" class="text-end">
        <v-btn class="primary" @click="$router.go(-1)">
          <v-icon left> mdi-chevron-double-left </v-icon>
          {{ `${this.$t("notice.edit.buttons.back")}` }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="ma-1">
      <v-col cols="4" class="d-flex">
        <v-card class="flex-grow-1 custom-bg-color" flat>
          <v-row>
            <v-col cols="6">
              <h6 class="plan-name">
                <div class="text-center">CURRENT PLAN</div>
              </h6>
            </v-col>
          </v-row>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <table class="table-width">
                  <tr>
                    <td class="text-color uppercase-text">
                      <b>{{ currentPlan?.plan?.title }}</b>
                    </td>
                    <td class="rounded-circle icon-container">
                      <v-icon color="yellow darken-2" class="star-icon"
                        >mdi-star</v-icon
                      >
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-comman mb-0 pb-0">
                      <h2>₹{{ currentPlan?.amount }}</h2>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-comman">
                      Expires On :
                      {{ getFormattedDate(currentPlan?.expiration_date) }}
                    </td>
                  </tr>
                  <tr>
                    <td v-if="textShow === true">
                      <v-badge
                        color="info"
                        :content="`Expires in ${planDay} days`"
                        inline
                      ></v-badge>
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-col cols="4" class="d-flex" v-if="nextPlan"> -->

      <v-col cols="4" class="d-flex" v-if="nextPlan?.plan?.title">
        <v-card class="flex-grow-1 next-custom-bg-color" flat>
          <v-row>
            <v-col cols="6">
              <h6 class="plan-name">
                <div class="text-center">NEXT PLAN</div>
              </h6>
            </v-col>
          </v-row>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <table class="table-width">
                  <tr>
                    <td class="text-color uppercase-text">
                      <b>{{ nextPlan?.plan?.title }}</b>
                    </td>
                    <td class="rounded-circle icon-container">
                      <v-icon color="yellow darken-2" class="star-icon"
                        >mdi-star</v-icon
                      >
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-comman mb-0 pb-0">
                      <h2>₹{{ userPlan.lessPrice }}</h2>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-comman">
                      Start On : {{ getFormattedDate(nextPlan?.start_date) }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-comman">
                      Expires On :
                      {{ getFormattedDate(nextPlan?.expiration_date) }}
                    </td>
                  </tr>
                </table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="ma-1" v-if="textShow === true && showPlan === true">
      <!-- <v-row class="ma-1"> -->
      <v-col cols="4" class="d-flex">
        <h1>Recommended Plan</h1>
      </v-col>
    </v-row>
    <!-- <v-row class="ma-1" v-if="showPlan === true"> -->

    <v-row class="text-center d-flex ma-1">
      <v-col cols="6" v-for="item in planData" :key="item.id">
        <v-card class="py-1 rounded-lg flex-grow-1 border-radius" flat>
          <v-card-text>
            <v-row>
              <v-col cols="1 d-flex justify-center align-center">
                <div class="plan-circle plan-container">
                  <v-icon color="yellow darken-2" class="star-icon"
                    >mdi-star</v-icon
                  >
                </div>
              </v-col>

              <v-col cols="2 d-flex justify-start align-self-center">
                <h4>{{ item.title }}</h4></v-col
              >
              <v-col cols="4 justify-start align-self-center">
                <v-row class="justify-center text-decoration-line-through">
                  <span>₹ {{ userPlan.totalPrice }}</span>
                </v-row>
                <v-row class="justify-center">
                  <b class="d-flex justify-start">
                    <span>₹ {{ userPlan.lessPrice }}</span>
                    <div class="text-number ms-1">
                      / For {{ item.number_of_days }} days
                    </div>
                  </b>
                </v-row>
                <v-row class="justify-center">
                  <b class="d-flex justify-start">
                    <span>₹ {{ planPrice }} (Per House) </span>
                  </b>
                </v-row>
              </v-col>
              <!-- <v-col cols="3">
            <input
              type="checkbox"
              id="autoRenewal"
              v-model="item.autoRenewal"
            />
            <label for="autoRenewal" class="ml-2">Auto Renewal</label>
          </v-col> -->

              <v-col cols="5 text-end">
                <v-btn
                  color="primary"
                  dark
                  class="px-8 ml-2 buy-button"
                  :class="{
                    'disable-events': item.id === currentPlan?.plan_id,
                  }"
                  @click="
                    item.id === currentPlan?.plan_id
                      ? handlePurchased()
                      : purchasePlan(item.id)
                  "
                  :loading="loading"
                >
                  {{
                    item.id === currentPlan?.plan_id ? "Purchased" : "Upgrade"
                  }}
                </v-btn></v-col
              >
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      planData: [],
      currentPlan: [],
      nextPlan: [],
      showPlan: [],
      planDay: [],
      textShow: [],
      userPlan: [],

      loaded: false,
    };
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    handlePurchased() {
      alert();
    },
    getPlan() {
      let _self = this;

      _self.$axios.get("societyadmin/plans").then((response) => {
        let data = response.data;

        if (data.status) {
          _self.planData = data.Plan;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    getFormattedDate(date) {
      if (!date) {
        return "N/A";
      }
      const parsedDate = new Date(date);
      const year = parsedDate.getFullYear();
      const month = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
      const day = parsedDate.getDate().toString().padStart(2, "0");
      return `${day}-${month}-${year}`;
    },
    getUserPlan() {
      let _self = this;

      _self.$axios.get("societyadmin/user-plan").then((response) => {
        let data = response.data;

        if (data.status) {
          _self.currentPlan = data.current;
          _self.nextPlan = data.next;
          _self.showPlan = data.showPlan;
          _self.textShow = data.textShow;
          _self.planDay = data.planDay;
          _self.userPlan = data.planData;
          _self.planPrice = data.planPrice;

        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    purchasePlan(id) {
      let _self = this;
      let plan_id = id;

      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          _self.$axios
            .post("/societyadmin/plan-purchase", { plan_id: plan_id })

            .then((response) => {
              let data = response.data;
              _self.loading = false;
              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 3000,
                });
                setTimeout(() => {
                  window.location.reload();
                }, 3000);
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  this.setAlert({
                    showAlert: true,
                    message: data.errors[0].message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                }
              }
            });
        }
      });
    },
  },
  mounted() {
    this.getPlan();
    this.getUserPlan();
  },
};
</script>

<style scoped>
.disable-events {
  pointer-events: none;
  background-color: #bc5d83 !important;
}
.table-width {
  width: 100%;
}
.custom-bg-color {
  background-color: #00b79b;
  border-radius: 20px;

  position: relative;
}
.plan-name {
  background-color: #ffcc00;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.text-color {
  color: #ffcc00;
}
.text-comman {
  color: #ffffff;
}
.expiry-text {
  color: #ee1818;
}
.plan-name {
  background-color: #ffcc00;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.next-plan-name {
  background-color: #ffffff;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.rounded-circle {
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon-container i {
  color: #ffcc00;
}
.next-custom-bg-color {
  background-color: #0082cd;
  border-radius: 20px;
  position: relative;
}
.icon-container {
  position: absolute;
  right: 0.6rem;
  top: 1rem;
}
.card-size {
  padding-top: 12px;
}
.text-number {
  color: #91c8e9;
}
.border-radius {
  border-radius: 20px;
}
.icon-container i[data-v-1a27a1a0] {
  color: #ffcc00;
}

.plan-container {
  position: absolute;
}
.plan-circle {
  width: 45px;
  height: 45px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plan-icon {
  color: #ffcc00;
}
.size-card {
  padding: 12px;
}
.uppercase-text {
  text-transform: uppercase;
}
.buy-button {
  background-color: #0082ce !important;
  color: #ffffff;
  border: 1px solid #007bff !important;
  padding: 8px 16px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  width: 135px;
  height: 40px;
  transition: background-color 0.3s;
}

.buy-button:hover {
  background-color: #0056b3 !important;
  color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.buy-button:disabled {
  background-color: #55aae2 !important;
  color: #ffffff;
  border: 1px solid #55aae2 !important;
  cursor: not-allowed;
  transition: background-color 0.3s;
}
.star-icon {
  font-size: 40px;
}
</style>
